/* A fragment of markup the console wrote, drawn in the site's own type.
 *
 * The `dangerouslySetInnerHTML` is deliberate and it is narrow. What arrives
 * here is an answer that the API rebuilt from an allowlist before storing it —
 * eleven tags, one attribute, no scripts, no styles (api/src/utils/sanitize.ts) —
 * or one of the site's own built-in answers, escaped in useFaqs. Nothing else
 * on the storefront renders HTML it was handed, and nothing else should.
 *
 * The styling is here rather than at each call site because a list written in
 * the console has to look like a list on the page: the editor offers bold,
 * italic, a link and two kinds of list, and each of those five needs a rule
 * or it renders as an unstyled browser default in the middle of the design.
 */

type RichTextProps = {
  html: string
  className?: string
}

export function RichText({ html, className = '' }: RichTextProps) {
  return (
    <div className={`rich-text ${className}`} dangerouslySetInnerHTML={{ __html: html }} />
  )
}

export default RichText
